import { render, staticRenderFns } from "./SectionWhyPartnership.vue?vue&type=template&id=bea7c482&scoped=true"
import script from "./SectionWhyPartnership.vue?vue&type=script&lang=ts"
export * from "./SectionWhyPartnership.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhyPartnership.vue?vue&type=style&index=0&id=bea7c482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea7c482",
  null
  
)

export default component.exports